module.exports = __webpack_public_path__ + "static/media/job-growth-decline.f92beb9d.jpg";